// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Market table: \`th\` must stay \`table-cell\` — \`display: flex\` on \`th\` breaks column alignment with \`td\`. */
.market_page .market_update_sec .desktoptable .table.market-spot-pairs-table {
  width: 100%;
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0;
}

/* Market table: click column headers to cycle sort (no separate Gainers/Losers dropdown) */
.market_page .market_update_sec .desktoptable .table thead th.market-th-sort {
  display: table-cell;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  font-weight: 600;
}

.market_page .market_update_sec .desktoptable .table thead th.market-th-sort:hover {
  opacity: 0.92;
}

.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0;
}

.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__text {
  margin-right: 2px;
}

/* Default state: up/down asset; asc/desc: text arrows for clear direction */
.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  margin-left: 4px;
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows--dual {
  margin-left: 4px;
  line-height: 0;
}

.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrowsImg {
  display: block;
  width: 10px;
  height: auto;
  max-height: 14px;
  object-fit: contain;
  opacity: 0.75;
}

body.light_theme .market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrowsImg {
  opacity: 0.7;
}

.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows .is-active {
  opacity: 1;
  color: #fcd535;
}

.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows .is-mute {
  opacity: 0.3;
  color: rgba(255, 255, 255, 0.45);
}

body.light_theme .market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows .is-mute {
  color: rgba(7, 8, 8, 0.3);
}

/* 24h Volume cell: a touch darker than very light table text (matches style.css; scoped backup) */
/* Volume: \`.desktoptable\` is inside \`.custom-tab-content\` (not the other way around) — the old selector never matched. */
.market_page .market_update_sec .custom-tab-content .desktoptable table.table tbody td .volume_price {
  color: #d8dde4 !important;
}

/* Light theme: dark volume text (matches other numeric cells on the market table) */
body.light_theme .market_page .market_update_sec .custom-tab-content .desktoptable table.table tbody td .volume_price {
  color: #0f172a !important;
}

/* Stacked white cards: always dark 24h volume (parent td color #F7F7F7 was washing it out) */
@media screen and (max-width: 767.98px) {
  .market_update_table .custom-tab-content .desktoptable table.table tbody td .volume_price {
    color: #0f172a !important;
  }
}

/* Quote row: custom select + tbltabs (Market index) */
.market-tbltabs-row {
  margin: 12px 0 10px;
  justify-content: space-between;
  flex-direction: row-reverse;
}

/* Scroll strip + optional prev/next (arrows only when content overflows — see MarketTblTabsScroll) */
.market-tbltabs-scroll {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
}

.market-tbltabs-scroll__viewport {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  touch-action: pan-x;
  /* Hide scrollbar; scrolling still works (drag / touch / arrow buttons) */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.market-tbltabs-scroll__viewport::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.market-tbltabs-scroll__btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid rgb(255 255 255 / 0%);
  background: rgb(255 255 255 / 0%);
  color: #eaeaed;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

/* .market-tbltabs-scroll__btn:hover {
  background: rgba(255, 255, 255, 0.12);
} */

.market-tbltabs-scroll__btn i {
  font-size: 18px;
  line-height: 1;
  pointer-events: none;
}

.market-tbltabs-scroll__btn.is-hidden {
  display: none !important;
}

.market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list {
  margin: 0;
  flex-wrap: nowrap;
  width: max-content;
  max-width: none;
  overflow: visible;
  white-space: nowrap;
}

.market_page .market-tbltabs-scroll__btn {
  color: #6f6f6f;
}

/* body.light_theme .market_page .market-tbltabs-scroll__btn:hover {
  background: rgba(15, 23, 42, 0.08);
} */

/* Top row: Favorites / Spot / Cryptos / … — same arrow scroll as subcategory chips */
.market_update_sec.market_update_table .d-flex-between.custom_dlflex .market-main-pills-scroll {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.market-main-pills-scroll .market-tbltabs-scroll__viewport ul.nav.nav-pills.mb-2.overflowx_scroll.funds_tab.market_tabs {
  overflow: visible !important;
  width: max-content;
  max-width: none;
  flex-wrap: nowrap !important;
  white-space: nowrap;
}

.market-main-pills-scroll .market-tbltabs-scroll__viewport ul.nav.nav-pills .nav-item {
  flex-shrink: 0;
}

/* Mobile: single-row horizontal scroll for category tabs + compact select */
@media screen and (max-width: 767.98px) {
  .market-tbltabs-row {
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    margin: 10px 0 8px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .market-tbltabs-row .market-quote-select {
    flex-shrink: 0;
  }

  .market-tbltabs-row .market-quote-select__trigger {
    min-width: 88px;
    max-width: 132px;
    padding: 6px 10px;
    font-size: 13px;
    border-radius: 8px;
  }

  .market-tbltabs-row .market-quote-select__label {
    flex: 1 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .market-tbltabs-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list {
    flex-wrap: nowrap !important;
    gap: 2px;
    padding: 2px 0 2px;
  }

  .market-tbltabs-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list li {
    flex-shrink: 0;
  }

  .market-tbltabs-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list li button {
    white-space: nowrap;
    padding: 4px 10px;
    font-size: 12px;
    border-radius: 6px;
  }
}

.market-quote-select {
  position: relative;
  flex-shrink: 0;
  z-index: 4;
}

.market-quote-select__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 180px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  color: #ededed;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  cursor: pointer;
  line-height: 1.2;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.market-quote-select__trigger:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.market-quote-select__trigger.is-open {
  border-color: #fcd5351f;
  background: rgba(252, 213, 53, 0.04);
}

body.light_theme .market-quote-select__trigger {
  color: #0f172a;
  background: #F6F6F7;
  border: 1px solid #E2E8F0;
}

body.light_theme .market-quote-select__trigger:hover {
  background: #E2E8F0;
  border-color: #CBD5E1;
}

body.light_theme .market-quote-select__trigger.is-open {
  border-color: #3b82f6;
  background: #F1F5F9;
}

.market-quote-select__label {
  text-align: left;
}

.market-quote-select__chev {
  font-size: 18px;
  color: #f1f1f1;
}

body.light_theme .market-quote-select__chev {
  color: #475569;
}

.market-quote-select__panel {
  list-style: none;
  margin: 8px 0 0;
  padding: 6px 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  background: rgba(30, 32, 38, 0.95);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
  max-height: 260px;
  overflow-y: auto;
  z-index: 5;
  animation: market-dropdown-fade-in 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes market-dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

body.light_theme .market-quote-select__panel {
  background: #fff;
  border: 1px solid #E2E8F0;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
  animation: none;
}

.market-quote-select__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #d1d4dc;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s ease;
}

body.light_theme .market-quote-select__option {
  color: #334155;
}

.market-quote-select__option:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
}

body.light_theme .market-quote-select__option:hover {
  background: #F1F5F9;
  color: #0f172a;
}

.market-quote-select__option[aria-selected="true"] {
  color: #d1aa67;
  font-weight: 600;
  background: rgba(252, 213, 53, 0.05);
}

body.light_theme .market-quote-select__option[aria-selected="true"] {
  color: #2a2a2a;
  background: #f5f5f5;
}

body.light_theme .market-quote-select__option[aria-selected="true"]:hover {
  background: #f5f5f5;
}

.market-quote-select__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #d1aa67;
  color: #0f172a;
  flex-shrink: 0;
  font-weight: bold;
}

body.light_theme .market-quote-select__check {
  background: #383838;
  color: #fff;
}

.market-quote-select__check i {
  font-size: 12px;
  line-height: 1;
}

.market-quote-select__panel::-webkit-scrollbar {
  width: 6px;
}

.market-quote-select__panel::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 6px;
}

body.light_theme .market-quote-select__panel::-webkit-scrollbar-thumb {
  background: #CBD5E1;
}

/* Mobile: quote filter opens full-screen style sheet (see MarketQuoteSelect.jsx) */
.market_crypto_select_currency {
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  /* max-width: 140px; */
  padding: 0px 0px;
  font-size: 18px;
  font-weight: 500;
  color: #0f172a;
  background: none;
  border: none;
  border-radius: 0px;
  cursor: pointer;
  line-height: 1.2;
}

@media screen and (max-width: 767.98px) {
  .market-quote-select .market_crypto_select_currency.mobile-view {
    display: flex !important;
  }
}

.market_crypto_select_currency__label {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.market_crypto_select_currency i {
  font-size: 18px;
  color: #64748b;
  flex-shrink: 0;
}

.market-quote-select-mobile-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999999;
  background: rgba(30, 35, 41, 0.85);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
  animation: market-quote-mobile-fade 0.2s ease;
}

body.light_theme .market-quote-select-mobile-overlay {
  background: rgb(255 255 255 / 20%);
}

@keyframes market-quote-mobile-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.market-quote-select-mobile-sheet {
  width: 100%;
  max-width: 100%;
  max-height: min(88vh, 640px);
  background: #1e232978;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  padding: 0 0 16px;
  animation: market-quote-mobile-slide 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

body.light_theme .market-quote-select-mobile-sheet {
  background: #ffffffb3;
  box-shadow: 0 -8px 40px rgba(15, 23, 42, 0.18);
}

@keyframes market-quote-mobile-slide {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

.market-quote-select-mobile-sheet__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 8px;
  border-bottom: 1px solid #2b3139;
}

body.light_theme .market-quote-select-mobile-sheet__head {
  border-bottom: 1px solid #f1f5f9;
}

.market-quote-select-mobile-sheet__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #eaecef;
}

body.light_theme .market-quote-select-mobile-sheet__title {
  color: #0f172a;
}

.market-quote-select-mobile-sheet__close {
  border: 0;
  background: transparent;
  padding: 4px;
  line-height: 1;
  cursor: pointer;
  color: #94a3b8;
  border-radius: 8px;
}

.market-quote-select-mobile-sheet__close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

body.light_theme .market-quote-select-mobile-sheet__close:hover {
  color: #475569;
  background: #f1f5f9;
}

.market-quote-select-mobile-sheet__close i {
  font-size: 22px;
}

.market-quote-select-mobile-list {
  list-style: none;
  margin: 0;
  padding: 8px 0 12px;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.market-quote-select-mobile-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  padding: 14px 20px;
  border: 0;
  background: transparent;
  font-size: 16px;
  color: #eaecef;
  cursor: pointer;
  text-align: left;
}

body.light_theme .market-quote-select-mobile-option {
  color: #0f172a;
}

.market-quote-select-mobile-option:hover,
.market-quote-select-mobile-option:focus-visible {
  background: #2b3139;
}

body.light_theme .market-quote-select-mobile-option:hover,
body.light_theme .market-quote-select-mobile-option:focus-visible {
  background: #f8fafc;
}

.market-quote-select-mobile-option__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eaecef;
  color: #1e2329;
  flex-shrink: 0;
}

body.light_theme .market-quote-select-mobile-option__check {
  background: #0f172a;
  color: #fff;
}

.market-quote-select-mobile-option__check i {
  font-size: 13px;
  line-height: 1;
}

.market-quote-select-mobile-sheet__confirm {
  margin: 8px 16px 0;
  width: calc(100% - 32px);
  padding: 14px 16px;
  border: 0;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
  background: #2b3139;
  cursor: pointer;
}

body.light_theme .market-quote-select-mobile-sheet__confirm {
  color: #fff;
  background: #1e293b;
}

.market-quote-select-mobile-sheet__confirm:hover {
  background: #475569;
}

body.light_theme .market-quote-select-mobile-sheet__confirm:hover {
  background: #334155;
}

/* body.light_theme .market-quote-select-mobile-sheet {
  background: #fff;
} */

/* Alpha tab: chain/pool filter pills (screenshot layout) */
.market-alpha-row {
  justify-content: space-between;
  flex-direction: row;
  margin: 12px 0 10px;
}

.market-alpha-row .market-tbltabs-scroll {
  flex: 1 1 auto;
  min-width: 0;
}

.market-alpha-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list {
  margin: 0;
}

.market-alpha-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  width: auto;
  margin: 0;
}

.market-alpha-filters__chainBtn,
.market-alpha-filters__poolBtn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #eef2f714;
  background: #ffffff14;
  border-radius: 14px;
  padding: 10px 14px;
  height: 44px;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

body.light_theme .market-alpha-filters__chainBtn,
body.light_theme .market-alpha-filters__poolBtn {
  border: 1px solid #eef2f7;
  background: #ffffff;
  color: #0f172a;
}

.market-alpha-filters__chainBtn {
  flex: 1 1 auto;
  justify-content: flex-start;
  min-width: 260px;
}

.market-alpha-filters__poolBtn {
  flex: 0 0 auto;
  min-width: 220px;
  justify-content: space-between;
}

.market-alpha-filters__chainIcons {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-left: 6px;
}

.market-alpha-filters__chainIcon {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  object-fit: contain;
  padding: 5px;
}

.market-alpha-filters__chainIcon--dummy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #334155;
  padding: 0;
}

.market-alpha-filters__chev {
  font-size: 18px;
  color: #e3e3e3;
  margin-left: auto;
}

body.light_theme .market-alpha-filters__chev {
  color: #0f172a;
}

.market-alpha-chain {
  position: relative;
  flex: 1 1 auto;
  min-width: 260px;
}

.market-alpha-chain__panel {
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  width: 360px;
  max-width: min(92vw, 420px);
  max-height: 420px;
  overflow: auto;
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  box-shadow: 0 18px 60px rgba(15, 23, 42, 0.12);
  padding: 10px;
  z-index: 30;
}

.market-alpha-chain__opt {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 12px;
  border: none;
  background: transparent;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  color: #0f172a;
  font-size: 15px;
  font-weight: 500;
}

.market-alpha-chain__opt:hover {
  background: #f8fafc;
}

.market-alpha-chain__optLeft {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.market-alpha-chain__optIcon {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #0f172a;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.market-alpha-chain__optIcon--all {
  background: #e6e6e6;
  border-color: #e6e6e6;
  position: relative;
}

.market-alpha-chain__optIcon--all::after {
  content: "";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #bdbdbd;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.market-alpha-chain__check {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #0f172a;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.market-alpha-chain__check i {
  font-size: 13px;
}

/* Pool picker (Select Pool) – overlay panel (screenshot layout) */
.market-alpha-pool {
  position: relative;
}

.market-alpha-pool__panel {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  width: 310px;
  max-width: min(92vw, 520px);
  background: #f8f8f8;
  border-radius: 15px;
  border: 1px solid #eef2f7;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.18);
  padding: 14px;
  max-height: min(70vh, 640px);
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 40;
}

.market-alpha-pool__search {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  background: #f1f5f9;
  border: 1px solid #eef2f7;
}

.market-alpha-pool__search i {
  font-size: 20px;
  color: #94a3b8;
}

.market-alpha-pool__search input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  width: 100%;
}

.market-alpha-pool__tabs {
  display: flex;
  gap: 22px;
  align-items: flex-end;
  padding: 4px 2px 2px;
  border-bottom: 1px solid #eef2f7;
}

.market-alpha-pool__tab {
  border: none;
  background: transparent;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: #94a3b8;
  cursor: pointer;
  position: relative;
}

.market-alpha-pool__tab.is-active {
  color: #0f172a;
}

.market-alpha-pool__tab.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 34px;
  height: 3px;
  border-radius: 999px;
  background: #0f172a;
}

.market-alpha-pool__list {
  overflow: auto;
  flex: 1 1 auto;
  padding: 2px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.market-alpha-pool__item {
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 12px;
  border-radius: 16px;
}

.market-alpha-pool__item:hover {
  background: #f8fafc;
}

.market-alpha-pool__item.is-selected {
  background: #f8fafc;
}

.market-alpha-pool__itemLeft {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.market-alpha-pool__itemIcon {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: #f1f5f9;
  border: none;
  object-fit: contain;
  padding: 0px;
  flex-shrink: 0;
}

.market-alpha-pool__itemIcon--all {
  background: #0f172a;
  border-color: #0f172a;
  position: relative;
}

.market-alpha-pool__itemIcon--all::after {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ffffff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.market-alpha-pool__itemText {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.market-alpha-pool__itemTitle {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  /* color: #0f172a; */
  line-height: 1.15;
}

.market-alpha-pool__itemSub {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
  text-align: left;
}

.market-alpha-pool__tick {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #0f172a;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0;
}

.market-alpha-pool__item.is-selected .market-alpha-pool__tick {
  opacity: 1;
}

.market-alpha-pool__tick i {
  font-size: 13px;
}

.market-alpha-pool__actions {
  display: flex;
  gap: 14px;
  padding-top: 8px;
}

.market-alpha-pool__btn {
  height: 39px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  flex: 1 1;
}

.market-alpha-pool__btn--ghost {
  background: #f1f5f9;
  color: #0f172a;
}

.market-alpha-pool__btn--primary {
  background: #2b2f36;
  color: #ffffff;
}

@media (min-width: 768px) {
  /* anchored panel on desktop too */
}

@media (max-width: 767.98px) {
  .market-alpha-row {
    flex-wrap: wrap;
    gap: 10px;
  }

  .market-alpha-filters {
    width: 100%;
    justify-content: space-between;
  }

  .market-alpha-filters__chainBtn,
  .market-alpha-filters__poolBtn {
    width: 100%;
    min-width: 0;
  }

  .market-quote-select-mobile-option__check {
    width: 18px;
    height: 18px;
  }

  .market-alpha-filters__chainIcons {
    margin-left: auto;
  }

  .market-alpha-chain__panel {
    width: 100%;
    max-width: 100%;
  }

  .market-alpha-pool__panel {
    width: 100%;
    right: 0;
    left: 0;
    margin: 0 auto;
  }

  .market-quote-select-mobile-sheet__confirm {
    padding: 11px 16px;
    font-size: 14px;
  }

}

/* Market page table: mobile shows only first 2 columns */
@media (max-width: 767.98px) {


  .market-tbltabs-scroll__btn {
    position: relative;
  }

  .market-tbltabs-scroll__btn--prev {
    left: -10px;
  }

  .market-tbltabs-scroll__btn--next {
    right: -10px;
  }


  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table thead th:nth-child(n + 3) {
    display: none !important;
  }

  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table tbody td:nth-child(n + 3) {
    display: none !important;
  }

  /* With only 2 columns visible on mobile, keep the last column right-aligned */
  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table thead th:nth-child(2),
  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table tbody td:nth-child(2) {
    text-align: right !important;
  }
}


/* Favorites tab: same empty illustration as order history + login CTA (guest) */
.market_page .market-fav-empty-cell {
  padding: 48px 24px !important;
  text-align: center;
  vertical-align: middle;
  border-bottom: none !important;
}

.market_page .market-fav-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 220px;
  padding: 16px 0 8px;
}

.market_page .market-fav-empty__img {
  display: block;
  width: 120px;
  height: auto;
  max-height: 160px;
  object-fit: contain;
}

.market_page .market-fav-empty__login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #e2e2e2;
  text-decoration: none;
}

body.light_theme .market_page .market-fav-empty__login {
  color: #000;
}

.market_page .market-fav-empty__login:hover {
  text-decoration: underline;
}

.market_page .market-fav-empty__login i {
  font-size: 1.25rem;
}

.market_page .market-fav-empty__caption {
  margin: 0;
  max-width: 320px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #98a2b3;
  line-height: 1.4;
}

body.light_theme .market_page .market-fav-empty__caption {
  color: #64748b;
}

/* COIN-M / Options market panes: empty state padding */
.market_page .market-futures-placeholder .market-fav-empty {
  min-height: 350px;
  padding: 32px 16px 40px;
}

/* Featured top cards: structured skeleton (matches icon / pair / change / price / volume / chart) */
.market_page .market-featured-card-skeleton {
  pointer-events: none;
  cursor: default !important;
}

.market_page .market-featured-card-skeleton .market_value_card {
  flex: 1 1 auto;
  min-width: 0;
}

.market_page .market-featured-card-skeleton__pair {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  min-width: 0;
  font-size: inherit;
  font-weight: inherit;
}

@keyframes market-featured-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.market_page .market-featured-card-skeleton__bone {
  display: inline-block;
  border-radius: 8px;
  vertical-align: middle;
  background: linear-gradient(105deg,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0.05) 38%,
      rgba(255, 255, 255, 0.14) 50%,
      rgba(255, 255, 255, 0.05) 62%,
      rgba(255, 255, 255, 0.05) 100%);
  background-size: 220% 100%;
  background-position: 200% 0;
  animation: market-featured-skeleton-shimmer 1.4s ease-in-out infinite;
  animation-delay: var(--mfs-stagger, 0ms);
}

body.light_theme .market_page .market-featured-card-skeleton__bone {
  background: linear-gradient(105deg,
      rgba(7, 8, 8, 0.055) 0%,
      rgba(7, 8, 8, 0.055) 38%,
      rgba(7, 8, 8, 0.12) 50%,
      rgba(7, 8, 8, 0.055) 62%,
      rgba(7, 8, 8, 0.055) 100%);
  background-size: 220% 100%;
}

.market_page .market-featured-card-skeleton__icon {
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 50%;
}

.market_page .market-featured-card-skeleton__sym {
  width: 64px;
  height: 16px;
  border-radius: 6px;
}

.market_page .market-featured-card-skeleton__chg {
  width: 68px;
  height: 22px;
  border-radius: 8px;
}

.market_page .market-featured-card-skeleton__price {
  width: min(78%, 210px);
  height: 36px;
  border-radius: 10px;
}

.market_page .market-featured-card-skeleton__vol {
  width: min(92%, 280px);
  height: 15px;
  border-radius: 6px;
}

.market_page .market-featured-card-skeleton__chart-wrap {
  pointer-events: none;
}

.market_page .market-featured-card-skeleton__chart {
  display: block;
  width: 160px;
  height: 52px;
  border-radius: 12px 0 14px 0;
}

.market_page .market-featured-card-skeleton--mobile .market-featured-card-skeleton__chart {
  width: 104px;
  height: 44px;
}

@media (prefers-reduced-motion: reduce) {
  .market_page .market-featured-card-skeleton__bone {
    animation: none;
    background: rgba(255, 255, 255, 0.09);
    background-size: auto;
  }

  body.light_theme .market_page .market-featured-card-skeleton__bone {
    background: rgba(7, 8, 8, 0.09);
  }
}


@media (max-width:480px) {

  .market-alpha-filters {
    flex-direction: column;
    margin-top: 12px;
  }

  .market-alpha-chain {
    min-width: 100%;
  }

  .market-alpha-pool {
    width: 100%;
  }

  .market-alpha-pool__search input {
    font-size: 14px;
  }

  .market-alpha-pool__list {
    padding: 0px;
    gap: 0px;
  }

  .market-alpha-pool__search {
    padding: 6px 12px;
    border-radius: 10px;
  }

  .market_page .market-futures-placeholder .market-fav-empty {
    min-height: 300px;
  }

}

/* Market Alpha Theme Fixes (Dark mode default, light mode overrides) */
.market-alpha-chain__panel {
  background: #1e2329;
  border-color: #2b3139;
}

body.light_theme .market-alpha-chain__panel {
  background: #ffffff;
  border-color: #eef2f7;
}

.market-alpha-chain__opt {
  color: #eaecef;
}

body.light_theme .market-alpha-chain__opt {
  color: #0f172a;
}

.market-alpha-chain__opt:hover {
  background: #2b3139;
}

body.light_theme .market-alpha-chain__opt:hover {
  background: #f8fafc;
}

.market-alpha-chain__optIcon {
  background: #eaecef;
  color: #1e2329;
}

body.light_theme .market-alpha-chain__optIcon {
  background: #0f172a;
  color: #ffffff;
}

.market-alpha-chain__optIcon--all {
  background: #e6e6e6;
  border-color: #e6e6e6;

}

body.light_theme .market-alpha-chain__optIcon--all {
  background: #2b3139;
  border-color: #2b3139;
}

.market-alpha-chain__optIcon--all::after {
  background: #bdbdbd;
}

body.light_theme .market-alpha-chain__optIcon--all::after {
  background: #696c6f;
}

.market-alpha-chain__check {
  background: #eaecef;
  color: #1e2329;
}

body.light_theme .market-alpha-chain__check {
  background: #0f172a;
  color: #ffffff;
}

.market-alpha-pool__panel {
  background: #1e2329;
  border-color: #2b3139;
}

body.light_theme .market-alpha-pool__panel {
  background: #f8f8f8;
  border-color: #eef2f7;
}

.market-alpha-pool__search {
  background: #181a20;
  border-color: #2b3139;
}

body.light_theme .market-alpha-pool__search {
  background: #f1f5f9;
  border-color: #eef2f7;
}

.market-alpha-pool__search input {
  color: #eaecef;
}

body.light_theme .market-alpha-pool__search input {
  color: #0f172a;
}

.market-alpha-pool__tabs {
  border-bottom-color: #2b3139;
}

body.light_theme .market-alpha-pool__tabs {
  border-bottom-color: #eef2f7;
}

.market-alpha-pool__tab.is-active {
  color: #eaecef;
}

body.light_theme .market-alpha-pool__tab.is-active {
  color: #0f172a;
}

.market-alpha-pool__tab.is-active::after {
  background: #eaecef;
}

body.light_theme .market-alpha-pool__tab.is-active::after {
  background: #0f172a;
}

.market-alpha-pool__item:hover,
.market-alpha-pool__item.is-selected {
  background: #2b3139;
}

body.light_theme .market-alpha-pool__item:hover,
body.light_theme .market-alpha-pool__item.is-selected {
  background: #f8fafc;
}

.market-alpha-pool__itemTitle {
  color: #eaecef;
}

body.light_theme .market-alpha-pool__itemTitle {
  color: #0f172a;
}

.market-alpha-pool__itemIcon {
  background: #2b3139;
}

body.light_theme .market-alpha-pool__itemIcon {
  background: #f1f5f9;
}

.market-alpha-pool__itemIcon--all {
  background: #eaecef;
  border-color: #eaecef;
}

body.light_theme .market-alpha-pool__itemIcon--all {
  background: #0f172a;
  border-color: #0f172a;
}

.market-alpha-pool__itemIcon--all::after {
  background: #1e2329;
}

body.light_theme .market-alpha-pool__itemIcon--all::after {
  background: #ffffff;
}

.market-alpha-pool__tick {
  background: #eaecef;
  color: #1e2329;
}

body.light_theme .market-alpha-pool__tick {
  background: #0f172a;
  color: #ffffff;
}

.market-alpha-pool__btn--ghost {
  background: #2b3139;
  color: #eaecef;
}

body.light_theme .market-alpha-pool__btn--ghost {
  background: #f1f5f9;
  color: #0f172a;
}

.market-alpha-pool__btn--primary {
  background: #eaecef;
  color: #1e2329;
}

body.light_theme .market-alpha-pool__btn--primary {
  background: #2b2f36;
  color: #ffffff;
}

/* ==========================================================================
   Smooth Scroll/Slide Transition for Market Search Bar (Fixes jerky opening)
   ========================================================================== */

.market_update_table .searchBar.custom-tabs {
  width: 40px;
  min-width: 40px;
  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.8s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 10px;
}

.market_update_table .searchBar.custom-tabs.search_active {
  width: 300px;
  max-width: 100%;
  padding-left: 12px;
}

.market_update_table .searchBar.custom-tabs i {
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 0;
  transition: margin 0.45s cubic-bezier(0.4, 0, 0.2, 1);
}

.market_update_table .searchBar.custom-tabs.search_active i {
  margin-right: 8px;
}

.market_update_table .searchBar.custom-tabs .custom_search {
  display: block !important;
  width: 0;
  opacity: 0;
  padding: 0;
  border: none !important;
  outline: none !important;
  background: transparent;
  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease, padding 0.45s cubic-bezier(0.4, 0, 0.2, 1);
  flex-grow: 1;
  min-width: 0;
}

.market_update_table .searchBar.custom-tabs.search_active .custom_search {
  width: 100%;
  opacity: 1;
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Market/market-quote-select.css"],"names":[],"mappings":"AAAA,2GAA2G;AAC3G;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,2FAA2F;AAC3F;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,MAAM;AACR;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kGAAkG;AAClG,yHAAyH;AACzH;EACE,yBAAyB;AAC3B;;AAEA,oFAAoF;AACpF;EACE,yBAAyB;AAC3B;;AAEA,6FAA6F;AAC7F;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,qGAAqG;AACrG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;EACnB,yEAAyE;EACzE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,qDAAqD;AACvD;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH,qFAAqF;AACrF;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,qEAAqE;AACvE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mFAAmF;AACnF;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;EACrB,kCAA0B;UAA1B,0BAA0B;EAC1B,4BAA4B;EAC5B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yEAAyE;AAC3E;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH,2DAA2D;AAC3D;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,OAAO;IACP,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;AAEF;;AAEA,yDAAyD;AACzD;;;EAGE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,8EAA8E;EAC9E;;IAEE,4BAA4B;EAC9B;AACF;;;AAGA,gFAAgF;AAChF;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,oGAAoG;AACpG;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB;;;;;qCAKmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,qEAAqE;EACrE,wCAAwC;AAC1C;;AAEA;EACE;;;;;gCAK8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,qCAAqC;IACrC,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;EACjC;AACF;;;AAGA;;EAEE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;;AAEvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,eAAe;EACf,gFAAgF;EAChF,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,oHAAoH;EACpH,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,cAAc;AAChB","sourcesContent":["/* Market table: `th` must stay `table-cell` — `display: flex` on `th` breaks column alignment with `td`. */\n.market_page .market_update_sec .desktoptable .table.market-spot-pairs-table {\n  width: 100%;\n  table-layout: auto;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n/* Market table: click column headers to cycle sort (no separate Gainers/Losers dropdown) */\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort {\n  display: table-cell;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort:hover {\n  opacity: 0.92;\n}\n\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__cell {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 0;\n}\n\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__text {\n  margin-right: 2px;\n}\n\n/* Default state: up/down asset; asc/desc: text arrows for clear direction */\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 3px;\n  margin-left: 4px;\n  font-size: 11px;\n  line-height: 1;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows--dual {\n  margin-left: 4px;\n  line-height: 0;\n}\n\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrowsImg {\n  display: block;\n  width: 10px;\n  height: auto;\n  max-height: 14px;\n  object-fit: contain;\n  opacity: 0.75;\n}\n\nbody.light_theme .market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrowsImg {\n  opacity: 0.7;\n}\n\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows .is-active {\n  opacity: 1;\n  color: #fcd535;\n}\n\n.market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows .is-mute {\n  opacity: 0.3;\n  color: rgba(255, 255, 255, 0.45);\n}\n\nbody.light_theme .market_page .market_update_sec .desktoptable .table thead th.market-th-sort .market-th-sort__arrows .is-mute {\n  color: rgba(7, 8, 8, 0.3);\n}\n\n/* 24h Volume cell: a touch darker than very light table text (matches style.css; scoped backup) */\n/* Volume: `.desktoptable` is inside `.custom-tab-content` (not the other way around) — the old selector never matched. */\n.market_page .market_update_sec .custom-tab-content .desktoptable table.table tbody td .volume_price {\n  color: #d8dde4 !important;\n}\n\n/* Light theme: dark volume text (matches other numeric cells on the market table) */\nbody.light_theme .market_page .market_update_sec .custom-tab-content .desktoptable table.table tbody td .volume_price {\n  color: #0f172a !important;\n}\n\n/* Stacked white cards: always dark 24h volume (parent td color #F7F7F7 was washing it out) */\n@media screen and (max-width: 767.98px) {\n  .market_update_table .custom-tab-content .desktoptable table.table tbody td .volume_price {\n    color: #0f172a !important;\n  }\n}\n\n/* Quote row: custom select + tbltabs (Market index) */\n.market-tbltabs-row {\n  margin: 12px 0 10px;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n}\n\n/* Scroll strip + optional prev/next (arrows only when content overflows — see MarketTblTabsScroll) */\n.market-tbltabs-scroll {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.market-tbltabs-scroll__viewport {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-x: contain;\n  touch-action: pan-x;\n  /* Hide scrollbar; scrolling still works (drag / touch / arrow buttons) */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.market-tbltabs-scroll__viewport::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n.market-tbltabs-scroll__btn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border-radius: 8px;\n  border: 1px solid rgb(255 255 255 / 0%);\n  background: rgb(255 255 255 / 0%);\n  color: #eaeaed;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n/* .market-tbltabs-scroll__btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n} */\n\n.market-tbltabs-scroll__btn i {\n  font-size: 18px;\n  line-height: 1;\n  pointer-events: none;\n}\n\n.market-tbltabs-scroll__btn.is-hidden {\n  display: none !important;\n}\n\n.market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list {\n  margin: 0;\n  flex-wrap: nowrap;\n  width: max-content;\n  max-width: none;\n  overflow: visible;\n  white-space: nowrap;\n}\n\n.market_page .market-tbltabs-scroll__btn {\n  color: #6f6f6f;\n}\n\n/* body.light_theme .market_page .market-tbltabs-scroll__btn:hover {\n  background: rgba(15, 23, 42, 0.08);\n} */\n\n/* Top row: Favorites / Spot / Cryptos / … — same arrow scroll as subcategory chips */\n.market_update_sec.market_update_table .d-flex-between.custom_dlflex .market-main-pills-scroll {\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.market-main-pills-scroll .market-tbltabs-scroll__viewport ul.nav.nav-pills.mb-2.overflowx_scroll.funds_tab.market_tabs {\n  overflow: visible !important;\n  width: max-content;\n  max-width: none;\n  flex-wrap: nowrap !important;\n  white-space: nowrap;\n}\n\n.market-main-pills-scroll .market-tbltabs-scroll__viewport ul.nav.nav-pills .nav-item {\n  flex-shrink: 0;\n}\n\n/* Mobile: single-row horizontal scroll for category tabs + compact select */\n@media screen and (max-width: 767.98px) {\n  .market-tbltabs-row {\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 8px;\n    margin: 10px 0 8px;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  .market-tbltabs-row .market-quote-select {\n    flex-shrink: 0;\n  }\n\n  .market-tbltabs-row .market-quote-select__trigger {\n    min-width: 88px;\n    max-width: 132px;\n    padding: 6px 10px;\n    font-size: 13px;\n    border-radius: 8px;\n  }\n\n  .market-tbltabs-row .market-quote-select__label {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .market-tbltabs-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list {\n    flex-wrap: nowrap !important;\n    gap: 2px;\n    padding: 2px 0 2px;\n  }\n\n  .market-tbltabs-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list li {\n    flex-shrink: 0;\n  }\n\n  .market-tbltabs-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list li button {\n    white-space: nowrap;\n    padding: 4px 10px;\n    font-size: 12px;\n    border-radius: 6px;\n  }\n}\n\n.market-quote-select {\n  position: relative;\n  flex-shrink: 0;\n  z-index: 4;\n}\n\n.market-quote-select__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  min-width: 180px;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ededed;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  cursor: pointer;\n  line-height: 1.2;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.market-quote-select__trigger:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.16);\n  color: #ffffff;\n}\n\n.market-quote-select__trigger.is-open {\n  border-color: #fcd5351f;\n  background: rgba(252, 213, 53, 0.04);\n}\n\nbody.light_theme .market-quote-select__trigger {\n  color: #0f172a;\n  background: #F6F6F7;\n  border: 1px solid #E2E8F0;\n}\n\nbody.light_theme .market-quote-select__trigger:hover {\n  background: #E2E8F0;\n  border-color: #CBD5E1;\n}\n\nbody.light_theme .market-quote-select__trigger.is-open {\n  border-color: #3b82f6;\n  background: #F1F5F9;\n}\n\n.market-quote-select__label {\n  text-align: left;\n}\n\n.market-quote-select__chev {\n  font-size: 18px;\n  color: #f1f1f1;\n}\n\nbody.light_theme .market-quote-select__chev {\n  color: #475569;\n}\n\n.market-quote-select__panel {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 6px 0;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  background: rgba(30, 32, 38, 0.95);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);\n  max-height: 260px;\n  overflow-y: auto;\n  z-index: 5;\n  animation: market-dropdown-fade-in 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes market-dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\nbody.light_theme .market-quote-select__panel {\n  background: #fff;\n  border: 1px solid #E2E8F0;\n  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);\n  animation: none;\n}\n\n.market-quote-select__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 12px;\n  padding: 10px 16px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: #d1d4dc;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.15s ease;\n}\n\nbody.light_theme .market-quote-select__option {\n  color: #334155;\n}\n\n.market-quote-select__option:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: #ffffff;\n}\n\nbody.light_theme .market-quote-select__option:hover {\n  background: #F1F5F9;\n  color: #0f172a;\n}\n\n.market-quote-select__option[aria-selected=\"true\"] {\n  color: #d1aa67;\n  font-weight: 600;\n  background: rgba(252, 213, 53, 0.05);\n}\n\nbody.light_theme .market-quote-select__option[aria-selected=\"true\"] {\n  color: #2a2a2a;\n  background: #f5f5f5;\n}\n\nbody.light_theme .market-quote-select__option[aria-selected=\"true\"]:hover {\n  background: #f5f5f5;\n}\n\n.market-quote-select__check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #d1aa67;\n  color: #0f172a;\n  flex-shrink: 0;\n  font-weight: bold;\n}\n\nbody.light_theme .market-quote-select__check {\n  background: #383838;\n  color: #fff;\n}\n\n.market-quote-select__check i {\n  font-size: 12px;\n  line-height: 1;\n}\n\n.market-quote-select__panel::-webkit-scrollbar {\n  width: 6px;\n}\n\n.market-quote-select__panel::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 6px;\n}\n\nbody.light_theme .market-quote-select__panel::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n}\n\n/* Mobile: quote filter opens full-screen style sheet (see MarketQuoteSelect.jsx) */\n.market_crypto_select_currency {\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n  /* max-width: 140px; */\n  padding: 0px 0px;\n  font-size: 18px;\n  font-weight: 500;\n  color: #0f172a;\n  background: none;\n  border: none;\n  border-radius: 0px;\n  cursor: pointer;\n  line-height: 1.2;\n}\n\n@media screen and (max-width: 767.98px) {\n  .market-quote-select .market_crypto_select_currency.mobile-view {\n    display: flex !important;\n  }\n}\n\n.market_crypto_select_currency__label {\n  flex: 1 1 auto;\n  min-width: 0;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.market_crypto_select_currency i {\n  font-size: 18px;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.market-quote-select-mobile-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 999999999;\n  background: rgba(30, 35, 41, 0.85);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 0;\n  animation: market-quote-mobile-fade 0.2s ease;\n}\n\nbody.light_theme .market-quote-select-mobile-overlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n@keyframes market-quote-mobile-fade {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.market-quote-select-mobile-sheet {\n  width: 100%;\n  max-width: 100%;\n  max-height: min(88vh, 640px);\n  background: #1e232978;\n  backdrop-filter: blur(5px);\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 16px;\n  animation: market-quote-mobile-slide 0.28s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\nbody.light_theme .market-quote-select-mobile-sheet {\n  background: #ffffffb3;\n  box-shadow: 0 -8px 40px rgba(15, 23, 42, 0.18);\n}\n\n@keyframes market-quote-mobile-slide {\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n.market-quote-select-mobile-sheet__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 16px 8px;\n  border-bottom: 1px solid #2b3139;\n}\n\nbody.light_theme .market-quote-select-mobile-sheet__head {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.market-quote-select-mobile-sheet__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #eaecef;\n}\n\nbody.light_theme .market-quote-select-mobile-sheet__title {\n  color: #0f172a;\n}\n\n.market-quote-select-mobile-sheet__close {\n  border: 0;\n  background: transparent;\n  padding: 4px;\n  line-height: 1;\n  cursor: pointer;\n  color: #94a3b8;\n  border-radius: 8px;\n}\n\n.market-quote-select-mobile-sheet__close:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .market-quote-select-mobile-sheet__close:hover {\n  color: #475569;\n  background: #f1f5f9;\n}\n\n.market-quote-select-mobile-sheet__close i {\n  font-size: 22px;\n}\n\n.market-quote-select-mobile-list {\n  list-style: none;\n  margin: 0;\n  padding: 8px 0 12px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.market-quote-select-mobile-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 12px;\n  padding: 14px 20px;\n  border: 0;\n  background: transparent;\n  font-size: 16px;\n  color: #eaecef;\n  cursor: pointer;\n  text-align: left;\n}\n\nbody.light_theme .market-quote-select-mobile-option {\n  color: #0f172a;\n}\n\n.market-quote-select-mobile-option:hover,\n.market-quote-select-mobile-option:focus-visible {\n  background: #2b3139;\n}\n\nbody.light_theme .market-quote-select-mobile-option:hover,\nbody.light_theme .market-quote-select-mobile-option:focus-visible {\n  background: #f8fafc;\n}\n\n.market-quote-select-mobile-option__check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #eaecef;\n  color: #1e2329;\n  flex-shrink: 0;\n}\n\nbody.light_theme .market-quote-select-mobile-option__check {\n  background: #0f172a;\n  color: #fff;\n}\n\n.market-quote-select-mobile-option__check i {\n  font-size: 13px;\n  line-height: 1;\n}\n\n.market-quote-select-mobile-sheet__confirm {\n  margin: 8px 16px 0;\n  width: calc(100% - 32px);\n  padding: 14px 16px;\n  border: 0;\n  border-radius: 999px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n  background: #2b3139;\n  cursor: pointer;\n}\n\nbody.light_theme .market-quote-select-mobile-sheet__confirm {\n  color: #fff;\n  background: #1e293b;\n}\n\n.market-quote-select-mobile-sheet__confirm:hover {\n  background: #475569;\n}\n\nbody.light_theme .market-quote-select-mobile-sheet__confirm:hover {\n  background: #334155;\n}\n\n/* body.light_theme .market-quote-select-mobile-sheet {\n  background: #fff;\n} */\n\n/* Alpha tab: chain/pool filter pills (screenshot layout) */\n.market-alpha-row {\n  justify-content: space-between;\n  flex-direction: row;\n  margin: 12px 0 10px;\n}\n\n.market-alpha-row .market-tbltabs-scroll {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.market-alpha-row .market-tbltabs-scroll__viewport ul.tbltabs.market-tbltabs-list {\n  margin: 0;\n}\n\n.market-alpha-filters {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px;\n  width: auto;\n  margin: 0;\n}\n\n.market-alpha-filters__chainBtn,\n.market-alpha-filters__poolBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid #eef2f714;\n  background: #ffffff14;\n  border-radius: 14px;\n  padding: 10px 14px;\n  height: 44px;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n}\n\nbody.light_theme .market-alpha-filters__chainBtn,\nbody.light_theme .market-alpha-filters__poolBtn {\n  border: 1px solid #eef2f7;\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.market-alpha-filters__chainBtn {\n  flex: 1 1 auto;\n  justify-content: flex-start;\n  min-width: 260px;\n}\n\n.market-alpha-filters__poolBtn {\n  flex: 0 0 auto;\n  min-width: 220px;\n  justify-content: space-between;\n}\n\n.market-alpha-filters__chainIcons {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: 6px;\n}\n\n.market-alpha-filters__chainIcon {\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  object-fit: contain;\n  padding: 5px;\n}\n\n.market-alpha-filters__chainIcon--dummy {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: #334155;\n  padding: 0;\n}\n\n.market-alpha-filters__chev {\n  font-size: 18px;\n  color: #e3e3e3;\n  margin-left: auto;\n}\n\nbody.light_theme .market-alpha-filters__chev {\n  color: #0f172a;\n}\n\n.market-alpha-chain {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 260px;\n}\n\n.market-alpha-chain__panel {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 10px);\n  width: 360px;\n  max-width: min(92vw, 420px);\n  max-height: 420px;\n  overflow: auto;\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n  border-radius: 14px;\n  box-shadow: 0 18px 60px rgba(15, 23, 42, 0.12);\n  padding: 10px;\n  z-index: 30;\n}\n\n.market-alpha-chain__opt {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 12px;\n  cursor: pointer;\n  text-align: left;\n  color: #0f172a;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.market-alpha-chain__opt:hover {\n  background: #f8fafc;\n}\n\n.market-alpha-chain__optLeft {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.market-alpha-chain__optIcon {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  background: #0f172a;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.market-alpha-chain__optIcon--all {\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n  position: relative;\n}\n\n.market-alpha-chain__optIcon--all::after {\n  content: \"\";\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #bdbdbd;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.market-alpha-chain__check {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #0f172a;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.market-alpha-chain__check i {\n  font-size: 13px;\n}\n\n/* Pool picker (Select Pool) – overlay panel (screenshot layout) */\n.market-alpha-pool {\n  position: relative;\n}\n\n.market-alpha-pool__panel {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  width: 310px;\n  max-width: min(92vw, 520px);\n  background: #f8f8f8;\n  border-radius: 15px;\n  border: 1px solid #eef2f7;\n  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.18);\n  padding: 14px;\n  max-height: min(70vh, 640px);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  z-index: 40;\n}\n\n.market-alpha-pool__search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: #f1f5f9;\n  border: 1px solid #eef2f7;\n}\n\n.market-alpha-pool__search i {\n  font-size: 20px;\n  color: #94a3b8;\n}\n\n.market-alpha-pool__search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 18px;\n  font-weight: 600;\n  color: #0f172a;\n  width: 100%;\n}\n\n.market-alpha-pool__tabs {\n  display: flex;\n  gap: 22px;\n  align-items: flex-end;\n  padding: 4px 2px 2px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.market-alpha-pool__tab {\n  border: none;\n  background: transparent;\n  padding: 10px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #94a3b8;\n  cursor: pointer;\n  position: relative;\n}\n\n.market-alpha-pool__tab.is-active {\n  color: #0f172a;\n}\n\n.market-alpha-pool__tab.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 34px;\n  height: 3px;\n  border-radius: 999px;\n  background: #0f172a;\n}\n\n.market-alpha-pool__list {\n  overflow: auto;\n  flex: 1 1 auto;\n  padding: 2px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.market-alpha-pool__item {\n  width: 100%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px 12px;\n  border-radius: 16px;\n}\n\n.market-alpha-pool__item:hover {\n  background: #f8fafc;\n}\n\n.market-alpha-pool__item.is-selected {\n  background: #f8fafc;\n}\n\n.market-alpha-pool__itemLeft {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.market-alpha-pool__itemIcon {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  border: none;\n  object-fit: contain;\n  padding: 0px;\n  flex-shrink: 0;\n}\n\n.market-alpha-pool__itemIcon--all {\n  background: #0f172a;\n  border-color: #0f172a;\n  position: relative;\n}\n\n.market-alpha-pool__itemIcon--all::after {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #ffffff;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.market-alpha-pool__itemText {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.market-alpha-pool__itemTitle {\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n  /* color: #0f172a; */\n  line-height: 1.15;\n}\n\n.market-alpha-pool__itemSub {\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 500;\n  text-align: left;\n}\n\n.market-alpha-pool__tick {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  background: #0f172a;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  opacity: 0;\n}\n\n.market-alpha-pool__item.is-selected .market-alpha-pool__tick {\n  opacity: 1;\n}\n\n.market-alpha-pool__tick i {\n  font-size: 13px;\n}\n\n.market-alpha-pool__actions {\n  display: flex;\n  gap: 14px;\n  padding-top: 8px;\n}\n\n.market-alpha-pool__btn {\n  height: 39px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  flex: 1 1;\n}\n\n.market-alpha-pool__btn--ghost {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.market-alpha-pool__btn--primary {\n  background: #2b2f36;\n  color: #ffffff;\n}\n\n@media (min-width: 768px) {\n  /* anchored panel on desktop too */\n}\n\n@media (max-width: 767.98px) {\n  .market-alpha-row {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .market-alpha-filters {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .market-alpha-filters__chainBtn,\n  .market-alpha-filters__poolBtn {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .market-quote-select-mobile-option__check {\n    width: 18px;\n    height: 18px;\n  }\n\n  .market-alpha-filters__chainIcons {\n    margin-left: auto;\n  }\n\n  .market-alpha-chain__panel {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .market-alpha-pool__panel {\n    width: 100%;\n    right: 0;\n    left: 0;\n    margin: 0 auto;\n  }\n\n  .market-quote-select-mobile-sheet__confirm {\n    padding: 11px 16px;\n    font-size: 14px;\n  }\n\n}\n\n/* Market page table: mobile shows only first 2 columns */\n@media (max-width: 767.98px) {\n\n\n  .market-tbltabs-scroll__btn {\n    position: relative;\n  }\n\n  .market-tbltabs-scroll__btn--prev {\n    left: -10px;\n  }\n\n  .market-tbltabs-scroll__btn--next {\n    right: -10px;\n  }\n\n\n  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table thead th:nth-child(n + 3) {\n    display: none !important;\n  }\n\n  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table tbody td:nth-child(n + 3) {\n    display: none !important;\n  }\n\n  /* With only 2 columns visible on mobile, keep the last column right-aligned */\n  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table thead th:nth-child(2),\n  .market_page section.live_prices.mt-0.market_prices.market_update_sec.market_update_table .custom-tab-content .desktoptable table.table tbody td:nth-child(2) {\n    text-align: right !important;\n  }\n}\n\n\n/* Favorites tab: same empty illustration as order history + login CTA (guest) */\n.market_page .market-fav-empty-cell {\n  padding: 48px 24px !important;\n  text-align: center;\n  vertical-align: middle;\n  border-bottom: none !important;\n}\n\n.market_page .market-fav-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  min-height: 220px;\n  padding: 16px 0 8px;\n}\n\n.market_page .market-fav-empty__img {\n  display: block;\n  width: 120px;\n  height: auto;\n  max-height: 160px;\n  object-fit: contain;\n}\n\n.market_page .market-fav-empty__login {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e2e2;\n  text-decoration: none;\n}\n\nbody.light_theme .market_page .market-fav-empty__login {\n  color: #000;\n}\n\n.market_page .market-fav-empty__login:hover {\n  text-decoration: underline;\n}\n\n.market_page .market-fav-empty__login i {\n  font-size: 1.25rem;\n}\n\n.market_page .market-fav-empty__caption {\n  margin: 0;\n  max-width: 320px;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  color: #98a2b3;\n  line-height: 1.4;\n}\n\nbody.light_theme .market_page .market-fav-empty__caption {\n  color: #64748b;\n}\n\n/* COIN-M / Options market panes: empty state padding */\n.market_page .market-futures-placeholder .market-fav-empty {\n  min-height: 350px;\n  padding: 32px 16px 40px;\n}\n\n/* Featured top cards: structured skeleton (matches icon / pair / change / price / volume / chart) */\n.market_page .market-featured-card-skeleton {\n  pointer-events: none;\n  cursor: default !important;\n}\n\n.market_page .market-featured-card-skeleton .market_value_card {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.market_page .market-featured-card-skeleton__pair {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: nowrap;\n  min-width: 0;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n@keyframes market-featured-skeleton-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.market_page .market-featured-card-skeleton__bone {\n  display: inline-block;\n  border-radius: 8px;\n  vertical-align: middle;\n  background: linear-gradient(105deg,\n      rgba(255, 255, 255, 0.05) 0%,\n      rgba(255, 255, 255, 0.05) 38%,\n      rgba(255, 255, 255, 0.14) 50%,\n      rgba(255, 255, 255, 0.05) 62%,\n      rgba(255, 255, 255, 0.05) 100%);\n  background-size: 220% 100%;\n  background-position: 200% 0;\n  animation: market-featured-skeleton-shimmer 1.4s ease-in-out infinite;\n  animation-delay: var(--mfs-stagger, 0ms);\n}\n\nbody.light_theme .market_page .market-featured-card-skeleton__bone {\n  background: linear-gradient(105deg,\n      rgba(7, 8, 8, 0.055) 0%,\n      rgba(7, 8, 8, 0.055) 38%,\n      rgba(7, 8, 8, 0.12) 50%,\n      rgba(7, 8, 8, 0.055) 62%,\n      rgba(7, 8, 8, 0.055) 100%);\n  background-size: 220% 100%;\n}\n\n.market_page .market-featured-card-skeleton__icon {\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  border-radius: 50%;\n}\n\n.market_page .market-featured-card-skeleton__sym {\n  width: 64px;\n  height: 16px;\n  border-radius: 6px;\n}\n\n.market_page .market-featured-card-skeleton__chg {\n  width: 68px;\n  height: 22px;\n  border-radius: 8px;\n}\n\n.market_page .market-featured-card-skeleton__price {\n  width: min(78%, 210px);\n  height: 36px;\n  border-radius: 10px;\n}\n\n.market_page .market-featured-card-skeleton__vol {\n  width: min(92%, 280px);\n  height: 15px;\n  border-radius: 6px;\n}\n\n.market_page .market-featured-card-skeleton__chart-wrap {\n  pointer-events: none;\n}\n\n.market_page .market-featured-card-skeleton__chart {\n  display: block;\n  width: 160px;\n  height: 52px;\n  border-radius: 12px 0 14px 0;\n}\n\n.market_page .market-featured-card-skeleton--mobile .market-featured-card-skeleton__chart {\n  width: 104px;\n  height: 44px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .market_page .market-featured-card-skeleton__bone {\n    animation: none;\n    background: rgba(255, 255, 255, 0.09);\n    background-size: auto;\n  }\n\n  body.light_theme .market_page .market-featured-card-skeleton__bone {\n    background: rgba(7, 8, 8, 0.09);\n  }\n}\n\n\n@media (max-width:480px) {\n\n  .market-alpha-filters {\n    flex-direction: column;\n    margin-top: 12px;\n  }\n\n  .market-alpha-chain {\n    min-width: 100%;\n  }\n\n  .market-alpha-pool {\n    width: 100%;\n  }\n\n  .market-alpha-pool__search input {\n    font-size: 14px;\n  }\n\n  .market-alpha-pool__list {\n    padding: 0px;\n    gap: 0px;\n  }\n\n  .market-alpha-pool__search {\n    padding: 6px 12px;\n    border-radius: 10px;\n  }\n\n  .market_page .market-futures-placeholder .market-fav-empty {\n    min-height: 300px;\n  }\n\n}\n\n/* Market Alpha Theme Fixes (Dark mode default, light mode overrides) */\n.market-alpha-chain__panel {\n  background: #1e2329;\n  border-color: #2b3139;\n}\n\nbody.light_theme .market-alpha-chain__panel {\n  background: #ffffff;\n  border-color: #eef2f7;\n}\n\n.market-alpha-chain__opt {\n  color: #eaecef;\n}\n\nbody.light_theme .market-alpha-chain__opt {\n  color: #0f172a;\n}\n\n.market-alpha-chain__opt:hover {\n  background: #2b3139;\n}\n\nbody.light_theme .market-alpha-chain__opt:hover {\n  background: #f8fafc;\n}\n\n.market-alpha-chain__optIcon {\n  background: #eaecef;\n  color: #1e2329;\n}\n\nbody.light_theme .market-alpha-chain__optIcon {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n.market-alpha-chain__optIcon--all {\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n\n}\n\nbody.light_theme .market-alpha-chain__optIcon--all {\n  background: #2b3139;\n  border-color: #2b3139;\n}\n\n.market-alpha-chain__optIcon--all::after {\n  background: #bdbdbd;\n}\n\nbody.light_theme .market-alpha-chain__optIcon--all::after {\n  background: #696c6f;\n}\n\n.market-alpha-chain__check {\n  background: #eaecef;\n  color: #1e2329;\n}\n\nbody.light_theme .market-alpha-chain__check {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n.market-alpha-pool__panel {\n  background: #1e2329;\n  border-color: #2b3139;\n}\n\nbody.light_theme .market-alpha-pool__panel {\n  background: #f8f8f8;\n  border-color: #eef2f7;\n}\n\n.market-alpha-pool__search {\n  background: #181a20;\n  border-color: #2b3139;\n}\n\nbody.light_theme .market-alpha-pool__search {\n  background: #f1f5f9;\n  border-color: #eef2f7;\n}\n\n.market-alpha-pool__search input {\n  color: #eaecef;\n}\n\nbody.light_theme .market-alpha-pool__search input {\n  color: #0f172a;\n}\n\n.market-alpha-pool__tabs {\n  border-bottom-color: #2b3139;\n}\n\nbody.light_theme .market-alpha-pool__tabs {\n  border-bottom-color: #eef2f7;\n}\n\n.market-alpha-pool__tab.is-active {\n  color: #eaecef;\n}\n\nbody.light_theme .market-alpha-pool__tab.is-active {\n  color: #0f172a;\n}\n\n.market-alpha-pool__tab.is-active::after {\n  background: #eaecef;\n}\n\nbody.light_theme .market-alpha-pool__tab.is-active::after {\n  background: #0f172a;\n}\n\n.market-alpha-pool__item:hover,\n.market-alpha-pool__item.is-selected {\n  background: #2b3139;\n}\n\nbody.light_theme .market-alpha-pool__item:hover,\nbody.light_theme .market-alpha-pool__item.is-selected {\n  background: #f8fafc;\n}\n\n.market-alpha-pool__itemTitle {\n  color: #eaecef;\n}\n\nbody.light_theme .market-alpha-pool__itemTitle {\n  color: #0f172a;\n}\n\n.market-alpha-pool__itemIcon {\n  background: #2b3139;\n}\n\nbody.light_theme .market-alpha-pool__itemIcon {\n  background: #f1f5f9;\n}\n\n.market-alpha-pool__itemIcon--all {\n  background: #eaecef;\n  border-color: #eaecef;\n}\n\nbody.light_theme .market-alpha-pool__itemIcon--all {\n  background: #0f172a;\n  border-color: #0f172a;\n}\n\n.market-alpha-pool__itemIcon--all::after {\n  background: #1e2329;\n}\n\nbody.light_theme .market-alpha-pool__itemIcon--all::after {\n  background: #ffffff;\n}\n\n.market-alpha-pool__tick {\n  background: #eaecef;\n  color: #1e2329;\n}\n\nbody.light_theme .market-alpha-pool__tick {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n.market-alpha-pool__btn--ghost {\n  background: #2b3139;\n  color: #eaecef;\n}\n\nbody.light_theme .market-alpha-pool__btn--ghost {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.market-alpha-pool__btn--primary {\n  background: #eaecef;\n  color: #1e2329;\n}\n\nbody.light_theme .market-alpha-pool__btn--primary {\n  background: #2b2f36;\n  color: #ffffff;\n}\n\n/* ==========================================================================\n   Smooth Scroll/Slide Transition for Market Search Bar (Fixes jerky opening)\n   ========================================================================== */\n\n.market_update_table .searchBar.custom-tabs {\n  width: 40px;\n  min-width: 40px;\n  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.8s ease;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 6px 10px;\n}\n\n.market_update_table .searchBar.custom-tabs.search_active {\n  width: 300px;\n  max-width: 100%;\n  padding-left: 12px;\n}\n\n.market_update_table .searchBar.custom-tabs i {\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-right: 0;\n  transition: margin 0.45s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.market_update_table .searchBar.custom-tabs.search_active i {\n  margin-right: 8px;\n}\n\n.market_update_table .searchBar.custom-tabs .custom_search {\n  display: block !important;\n  width: 0;\n  opacity: 0;\n  padding: 0;\n  border: none !important;\n  outline: none !important;\n  background: transparent;\n  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease, padding 0.45s cubic-bezier(0.4, 0, 0.2, 1);\n  flex-grow: 1;\n  min-width: 0;\n}\n\n.market_update_table .searchBar.custom-tabs.search_active .custom_search {\n  width: 100%;\n  opacity: 1;\n  padding: 0 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
